import Vue from "vue";

/** Component modules */
import XLbackground from "@/components/XLbackground/index.js";
import XLtop from "@/components/XLtop/index.js";
import XLaboutUs from "@/components/XLaboutUs/index.js";
import XLproductPresentation from "@/components/XLproductPresentation/index.js";
import XLpartners from "@/components/XLpartners/index.js";
import XLfoot from "@/components/XLfoot/index.js";
import XLupload from "@/components/XLupload/index.js";
import XLvideo from "@/components/XLvideo/index.js";
import XLPageBanner from "@/components/XLPageBanner/index.js";
import XLtimerShaft from "@/components/XLtimerShaft/index.js";
import canvasView from "@/components/canvas/index.js";
import XLautomobile from "@/components/XLautomobile/index.js";

const components = [
  XLbackground,
  XLtop,
  XLaboutUs,
  XLproductPresentation,
  XLpartners,
  XLfoot,
  XLupload,
  XLvideo,
  XLPageBanner,
  XLtimerShaft,
  canvasView,
  XLautomobile
];

/** 加载自定义组件 */
components.forEach((component) => {
  Vue.component(component.name, component);
});
